// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__36sEJ","filesListContainer":"PosDisputesFiles_filesListContainer__2MGwM","filesButton":"PosDisputesFiles_filesButton__25kjv"};